<template>
    <div class="flex flex-col h-full">
        <page-header :buttons="pageActions.buttons" :additional="pageActions.additional" @method="methodHandler">
            <template slot="title">Communication</template>
        </page-header>

        <tabs :tabs="tabs" :active="startTab" @setTab="setActiveTab" ref="tabs"></tabs>

        <div class="flex xl:flex-row lg:flex-col md:flex-col sm:flex-col flex-grow">
            <div class="xl:w-3/4 lg:w-full md:w-full sm:w-full px-4 sm:px-6 lg:px-6 bg-white border-r border-gray-400 bg-gray-200">
                <div class="mt-2 grid grid-cols-12 row-gap-5 col-gap-4 sm:grid-cols-12" v-if="!loading" v-show="activeTab === 'details'">
                    <div class="sm:col-span-12">
                        <table class="w-full mb-4 internal-table">
                            <thead>
                                <tr>
                                    <th colspan="2">Communication Details</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="w-32">Subject</td>
                                    <td>{{ item.subject }}</td>
                                </tr>
                                <tr>
                                    <td>Message</td>
                                    <td>{{ item.body }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <h2 class="w-full col-span-12 pb-2 border-b-2 border-charcoal-900 text-left font-medium text-charcoal-900 mt-4">
                            Bounced Recipients
                        </h2>
                        <table class="min-w-full text-xs">
                            <thead>
                            <tr>
                                <th class="table-head-cell pl-0">Name</th>
                                <th class="table-head-cell pl-0 w-32">Number</th>
                            </tr>
                            </thead>
                            <tbody v-if="item.bounced_recipients.length">
                            <tr v-for="(item, index) in item.bounced_recipients" :key="index">
                                <td class="table-body-cell pl-0" :class="[ index % 2 !== 0 ? 'even' : 'odd' ]">
                                    <router-link :to="'/members/'+item.id+'/view'">{{ item.name }}</router-link>
                                </td>
                                <td class="table-body-cell pl-0" :class="[ index % 2 !== 0 ? 'even' : 'odd' ]">{{ item.number }}</td>
                            </tr>
                            </tbody>
                        </table>
                        <div v-if="item.bounced_recipients.length === 0" class="bg-green-200 py-2 text-sm text-green-700 text-center w-full -mt-px">No bounced recipients have been recorded</div>

                        <h2 class="w-full col-span-12 pb-2 border-b-2 border-charcoal-900 text-left font-medium text-charcoal-900 mt-4">
                            Recipients
                        </h2>
                        <table class="min-w-full text-xs">
                            <thead>
                            <tr>
                                <th class="table-head-cell pl-0">Name</th>
                                <th class="table-head-cell pl-0 w-32">Number</th>
                            </tr>
                            </thead>
                            <tbody v-if="item.recipients && item.recipients.length">
                                <tr v-for="(item, index) in item.recipients" v-bind:key="index">
                                    <td class="table-body-cell pl-0" :class="[ index % 2 !== 0 ? 'even' : 'odd' ]">
                                        <router-link :to="'/members/'+item.id+'/view'">{{ item.name }}</router-link>
                                    </td>
                                    <td class="table-body-cell pl-0" :class="[ index % 2 !== 0 ? 'even' : 'odd' ]">{{ item.number }}</td>
                                </tr>
                            </tbody>

                        </table>
                        <div v-if="!item.recipients || item.recipients.length === 0" class="bg-red-200 py-2 text-sm text-red-700 text-center w-full -mt-px">No recipients added to message</div>
                    </div>
                </div>
            </div>
            <div class="xl:w-1/4 lg:w-full md:w-full sm:w-full px-4 sm:px-6 lg:px-6">
                <div class="mt-2 grid grid-cols-1 row-gap-5 col-gap-4 sm:grid-cols-12" v-if="!loading">
                    <div class="sm:col-span-12">
                        <table class="w-full mb-6 internal-table">
                            <thead>
                                <tr>
                                    <th colspan="2">Meta</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Sent At</td>
                                    <td>{{ new Date(item.meta.sent_at) | moment("DD/MM/YYYY h:mm a") }}</td>
                                </tr>
                                <tr>
                                    <td>Sent By</td>
                                    <td v-if="item.meta.sent_by">{{ item.meta.sent_by.full_name }}</td>
                                    <td v-else>N/A</td>
                                </tr>
                                <tr>
                                    <td>Created At</td>
                                    <td>{{ new Date(item.meta.created_at) | moment("DD/MM/YYYY h:mm a") }}</td>
                                </tr>
                                <tr>
                                    <td>Created By</td>
                                    <td v-if="item.meta.created_by">{{ item.meta.created_by.full_name }}</td>
                                    <td v-else>N/A</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import * as router from "vue-router";
    import Tabs from "../../mixins/Tabs";
    import axios from "axios";

    export default {
        name: "CommunicationView",
        props: {
            id: { required: true },
            return: { required: false, default: '/communications' },
            page: { required: false, default: 'communications' }
        },
        mixins: [
            Tabs
        ],
        data: function () {
            return {
                tabs: [
                    {
                        name: 'Details',
                        slug: 'details'
                    }
                ],
                startTab: null,
                loading: true,
                item: {},
                pageActions: {},
            }
        },
        methods: {
            getData: function(){
                this.$Progress.start();

                axios.get(process.env.VUE_APP_API_URL + '/communications/'+this.id)
                .then(response => {
                    this.item = response.data;

                    this.pageActions = {
                        buttons: [
                            {
                                label: 'Close',
                                icon: 'times',
                                type: 'router-link',
                                iconClass: 'text-red-500',
                                link: this.return ? this.return : '/communications',
                            },
                        ],
                        additional: []
                    };

                    this.$Progress.finish();
                    this.loading = false;
                })
                .catch(() => {
                    this.$Progress.finish();
                    this.loading = false;
                });
            },
            methodHandler: function (method) {
                this[method]();
            },
            actionHandler: function (data) {
                this[data.method](data);
            },
        },
        mounted() {
            this.getData();
        }
    }
</script>

<style scoped>

</style>
